import { StyleSheet, Platform } from 'react-native';

import { colors } from '@styles/colors';

const commentHeight = 111;
const cardBackgroundColor = colors.Light_Gray_Prom;

export const styles = StyleSheet.create({
  root: { /*flex: 1*/ },
  header: {
    marginBottom: 20,
    fontSize: 20,
    fontWeight: '600',
    color: colors.Gray_1,
  },
  cards: {
    flexDirection: 'row',
    minHeight: 75,
    marginBottom: 25,
  },
  card: {
    //flexBasis: 1,
    //flexGrow: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 8,
    paddingTop: 25,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: cardBackgroundColor,
    backgroundColor:  '#FFFFFF', // cardBackgroundColor,
    ...Platform.select({
      ios: {
        shadowColor: 'gray',
        shadowOffset: { width: 3, height: 3 },
        shadowOpacity: 0.7,
        shadowRadius: 2,
      },
      android: { elevation: 6 },
    }),
    paddingHorizontal: 30,
    paddingVertical: 15,
  },
  cardMiddle: {
    marginHorizontal: 10,
  },

  cardActive: {
    borderColor: colors.Green_2_Prom,
  },
  cardIcon: {
    marginBottom: 7,
  },
  cardText: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 24,
    color: colors.Green_2_Prom,
  },
  cardDetail: {
    fontSize: 11,
    fontWeight: '400',
    //lineHeight: 21,
    color: colors.Gray_1,
    marginTop: 5,  
  },
  comment: {
    height: commentHeight,
  },
});
